import { jsxs, jsx } from "react/jsx-runtime";
const IconCheckCircleOutlineSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsxs("g", { fill: "currentColor", children: [
        /* @__PURE__ */ jsx("path", { d: "M10 .833A9.14 9.14 0 0 0 .833 10 9.14 9.14 0 0 0 10 19.167 9.14 9.14 0 0 0 19.167 10 9.14 9.14 0 0 0 10 .833ZM10 17.5A7.469 7.469 0 0 1 2.5 10c0-4.167 3.333-7.5 7.5-7.5s7.5 3.333 7.5 7.5-3.333 7.5-7.5 7.5Z" }),
        /* @__PURE__ */ jsx("path", { d: "m12.75 7.75-3.584 3.583-1.083-1.083a.806.806 0 0 0-1.167 0 .806.806 0 0 0 0 1.167l1.667 1.666a.9.9 0 0 0 .583.25.9.9 0 0 0 .584-.25l4.166-4.166a.806.806 0 0 0 0-1.167.806.806 0 0 0-1.166 0Z" })
      ] })
    ]
  }
);
export {
  IconCheckCircleOutlineSvg
};
